import React, { useEffect, useState } from "react";
import Footer from "../element/Footer";
import JSSidebar from "./JSSidebar";
import NavBar from "../element/NavBar";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import ApiKey from "../api/ApiKey";
import BaseApi from "../api/BaseApi";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useTranslation } from "react-i18next";


const JSEditAlert = () => {
  const { slug } = useParams();

  const [loading, setLoading] = useState(false);
  const [editAlert, setEditAlert] = useState({
    location: "",
    designation: "",
  });
  const [errors, setErrors] = useState({
    location: "",
    designation: "",
  });
  const [designationList, setDesignationList] = useState([]);
  const tokenKey = Cookies.get("tokenClient");
  let primaryColor = Cookies.get("primaryColor");
  let secondaryColor = Cookies.get("secondaryColor");
  const [t, i18n] = useTranslation("global");


  const [hoverFirstButtonColor, setHoverFirstButtonColor] = useState(false);

  const handleFirstButtonMouseEnter = () => {
    setHoverFirstButtonColor(true);
  };

  const handleFirstButtonMouseLeave = () => {
    setHoverFirstButtonColor(false);
  };

  const [hoverSecondButtonColor, setHoverSecondButtonColor] = useState(false);

  const handleSecondButtonMouseEnter = () => {
    setHoverSecondButtonColor(true);
  };

  const handleSecondButtonMouseLeave = () => {
    setHoverSecondButtonColor(false);
  };

  const navigate = useNavigate();

  useEffect(() => {
    // Check if tokenKey is not present
    if (!tokenKey) {
      // Redirect to the home page
      navigate("/user/jobseekerlogin");
    } else {
      // TokenKey is present, fetch data or perform other actions
      getData();
      window.scrollTo(0, 0);
    }
  }, [tokenKey, navigate]);

  const getData = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        BaseApi + `/alerts/edit/${slug}`,
        null, // Pass null as the request body if not required
        {
          headers: {
            "Content-Type": "application/json",
            key: ApiKey,
            token: tokenKey,
          },
        }
      );
      setLoading(false);
      if(response.data.status === 200) {
        setEditAlert(response.data.response.alert_detail);
        setDesignationList(response.data.response.designationlList);
        // console.log(editAlert);
      }
      if (response.data.status === 400) {
        Cookies.remove("tokenClient");
        Cookies.remove("user_type");
        Cookies.remove("fname");
        navigate("/");
        Swal.fire({
          title: response.data.message,
          icon: "warning",
          confirmButtonText: t("searchJobPage.close"),
        });
        
      }
    } catch (error) {
      setLoading(false);
      if (error.message === "Network Error") {
        Cookies.remove("tokenClient");
        Cookies.remove("user_type");
        Cookies.remove("fname");
        navigate("/");
        Swal.fire({
          title: t("tokenExpired.tokenExpired"),
          icon: "warning",
          confirmButtonText: t("jobDescription.close"),
        });
        setTimeout(function () {
          window.location.reload();
        }, 3000);
      }
      console.log("Cannot get designation list of edit alert page");
    }
  };

  const handleClick = async () => {
    console.log(editAlert);

    try {
      const newErrors = {};

      if (editAlert.location === "") {
        newErrors.location = t("jobseekerEditAlert.locationRequired");
        window.scrollTo(0, 0);
      }

      if (editAlert.designation === "") {
        newErrors.designation = t("jobseekerEditAlert.workingRelationRequired");
        window.scrollTo(0, 0);
      }

      setErrors(newErrors);

      if (Object.keys(newErrors).length === 0) {
        const confirmationResult = await Swal.fire({
          title: t("jobseekerEditAlert.confirmTitle"),
          text: t("jobseekerEditAlert.confirmTxt"),
          icon: "question",
          showCancelButton: true,
          confirmButtonText: t("jobseekerEditAlert.yes"),
          cancelButtonText: t("jobseekerEditAlert.no"),
        });
        if (confirmationResult.isConfirmed) {
          await axios.post(
            BaseApi + `/alerts/edit/${slug}`,
            editAlert, // Pass null as the request body if not required
            {
              headers: {
                "Content-Type": "application/json",
                key: ApiKey,
                token: tokenKey,
              },
            }
          );
          Swal.fire({
            title: t("jobseekerEditAlert.successTxt"),
            icon: "success",
            confirmButtonText: t("jobseekerEditAlert.close"),
          });
          navigate("/alerts/index");
        }
      }
    } catch (error) {
      if (error.message === "Network Error") {
        Cookies.remove("tokenClient");
        Cookies.remove("user_type");
        Cookies.remove("fname");
        navigate("/");
        Swal.fire({
          title: t("tokenExpired.tokenExpired"),
          icon: "warning",
          confirmButtonText: t("jobDescription.close"),
        });
        setTimeout(function () {
          window.location.reload();
        }, 3000);
      }
      Swal.fire({
        title: t("jobseekerEditAlert.failedTxt"),
        icon: "error",
        confirmButtonText: t("jobseekerEditAlert.close"),
      });
      console.log("Cannot edit alert!");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditAlert((prevalue) => {
      return {
        ...prevalue,
        [name]: value,
      };
    });
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  // Code for loading Location

  const [autocompleteService, setAutocompleteService] = useState(null);
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    // Load Google Maps AutocompleteService after component mounts
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyAfLv-IdHZm0Xy3kYlAm3TypjjqeUjra9Q&libraries=places`;
    script.onload = () => {
      setAutocompleteService(
        new window.google.maps.places.AutocompleteService()
      );
      console.log(autocompleteService);
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const handleLocationChange = (e) => {
    const { value } = e.target;
    setSuggestionTaken(false);
    if (value == "") {
      setSuggestionTaken(true);
    }
    if (value != "") {
      setErrors({
        location: "",
      });
    }

    setEditAlert((prevFilter) => ({
      ...prevFilter,
      location: value,
    }));

    if (autocompleteService) {
      // Call Google Maps Autocomplete API
      autocompleteService.getPlacePredictions(
        {
          input: value,
          types: ["(cities)"], // Restrict to cities if needed
        },
        (predictions, status) => {
          if (status === "OK" && predictions) {
            setSuggestions(
              predictions.map((prediction) => prediction.description)
            );
          } else {
            setSuggestions([]);
          }
        }
      );
    }
    if (editAlert.location === "") {
      setSuggestions([]);
    }
  };
  const [suggestionTaken, setSuggestionTaken] = useState(false);

  const handleSuggestionClick = (suggestion) => {
    // Update the input value with the clicked suggestion
    handleLocationChange({ target: { name: "location", value: suggestion } });

    setSuggestionTaken(true);
    // Clear the suggestions
    setSuggestions([]);
    // console.log(filterItem);
  };

  return (
    <>
      <NavBar />
      <div className="container changePassword JSEditAlert createJob">
        <div className="row">
          <div className="col-lg-3">
            <JSSidebar />
          </div>
          {loading ? (
            <div className="loader-container"></div>
          ) : (
            <>
              <div
                className="col-lg-9 mb-5"
                style={{
                  borderLeft: "2px solid #e6e8e7",
                  borderRight: "2px solid #e6e8e7",
                }}
              >
                <div className="d-flex mx-3 PageHeader ">
                  <img src="/Images/employerSide/icon9color.png" alt="" />
                  <h3 className="mx-2">{t("jobseekerEditAlert.editAlert")}</h3>
                </div>
                <form>
                  <div className="mb-5 mt-5">
                    <div class="form-outline mb-5 DashBoardInputBx">
                      <label class="form-label" for="form3Example1">
                      {t("jobseekerEditAlert.location")} <span className="RedStar">*</span>
                      </label>
                      <input
                        type="text"
                        id="form3Example1"
                        className={`form-control ${
                          errors.location && "input-error"
                        }`}
                        placeholder={t("jobseekerEditAlert.location")}
                        value={editAlert.location}
                        name="location"
                        onChange={handleLocationChange}
                      />
                      {suggestions.length > 0 && (
                        <div
                          className="suggestions"
                          style={{ display: suggestionTaken ? "none" : "" }}
                        >
                          <ul className="locationDropdown">
                            {suggestions.map((suggestion, index) => (
                              <div key={index} className="suggestion-item">
                                <li
                                  onClick={() =>
                                    handleSuggestionClick(suggestion)
                                  }
                                >
                                  <div className="eachLocation">
                                    <div className="locationIcon">
                                      <LocationOnIcon fontSize="small" />
                                    </div>{" "}
                                    <div className="locationSuggestion">
                                      {suggestion}
                                    </div>
                                  </div>{" "}
                                </li>
                              </div>
                            ))}
                          </ul>
                        </div>
                      )}
                      {errors.location && (
                        <div className="text-danger">{errors.location}</div>
                      )}
                    </div>
                    <div class="form-outline mb-5 DashBoardInputBx">
                      <label className="form-label" htmlFor="form3Example3">
                      {t("jobseekerEditAlert.workingRelation")}<span className="RedStar">*</span>
                      </label>
                      <select
                        className={`form-select ${
                          errors.designation && "input-error"
                        }`}
                        aria-label="Default select example"
                        name="designation"
                        value={editAlert.designation}
                        onChange={handleChange}
                      >
                        <option selected value="">
                        {t("jobseekerEditAlert.selectWorkingRelation")}
                        </option>
                        {designationList.map((i) => {
                          return <option value={i.id}>{i.name}</option>;
                        })}
                      </select>
                      {errors.designation && (
                        <div className="text-danger">{errors.designation}</div>
                      )}
                    </div>
                  </div>
                  <div className="bottomButtons EditAlertButtons">
                    <button
                      type="button"
                      className="btn btn-primary button1"
                      onClick={handleClick}
                      style={{
                        backgroundColor: hoverFirstButtonColor
                          ? secondaryColor
                          : primaryColor,
                        border: hoverFirstButtonColor
                          ? secondaryColor
                          : primaryColor,
                      }}
                      onMouseEnter={handleFirstButtonMouseEnter}
                      onMouseLeave={handleFirstButtonMouseLeave}
                    >
                      {t("jobseekerEditAlert.updateButton")}
                    </button>
                    <Link
                      to="/alerts/index"
                      type="button"
                      className="btn btn-primary button2"
                      style={{
                        color: hoverSecondButtonColor
                          ? primaryColor
                          : secondaryColor,
                        backgroundColor: "white",
                        border: hoverSecondButtonColor
                          ? `2px solid ${primaryColor}`
                          : `2px solid ${secondaryColor}`,
                      }}
                      onMouseEnter={handleSecondButtonMouseEnter}
                      onMouseLeave={handleSecondButtonMouseLeave}
                    >
                      {t("jobseekerEditAlert.backButton")}
                    </Link>
                  </div>
                </form>
              </div>
            </>
          )}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default JSEditAlert;
